import React from "react"
import { HStack, Stack, Text } from "@chakra-ui/react"

import Icon from "@components/Icon/Icon"

const ProductBuyNowPayLater = () => (
  <Stack spacing={2} py={2} direction={["column", "row"]} alignSelf="center">
    <Text textAlign={["center", "left"]}>buy now, pay later with</Text>
    <HStack>
      <Icon name="klarnaBadge" width="58px" height="24px" />
      <Icon name="afterpayBadge" width="68px" height="24px" />
      <Icon name="zipBadge" width="53px" height="24px" />
    </HStack>
  </Stack>
)

export default ProductBuyNowPayLater
